"use client";

import { useRouter } from "next/navigation";
import { SplashScreen } from "@/components/minimal-components/loading-screen";
import { useEffect } from "react";

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    router.push("/dashboard/app");
  }, [router]);

  return <SplashScreen />;
}
